export function initializeTawkToScript(scriptUrl: string): void {
    if (typeof window === "undefined") return;

    (window as any).Tawk_API = (window as any).Tawk_API || {}; // Ensure Tawk_API is available globally
    (window as any).Tawk_LoadStart = new Date();

    // Check if the script is already added to avoid duplicate scripts
    if (document.getElementById("tawk-to-script")) {
        return;
    }

    const script = document.createElement("script");
    script.id = "tawk-to-script";
    script.async = true;
    script.src = scriptUrl;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    // Fix Tawk script blocking issues
    script.onload = () => {
        document.addEventListener("DOMContentLoaded", () => {
            const iframe = document.querySelectorAll(".widget-visible iframe")[1];
            if (iframe) {
                (iframe as HTMLElement).style.display = "none";
            }
        });
    };
}
